<template>
  <el-card shadow="never"
    ><el-page-header @back="goBack" content="修改课程信息"> </el-page-header>
    <el-divider></el-divider>
    <!-- 表单 -->
    <div class="course-chapter-area">
      <el-form ref="formNewCourse" :model="formNewCourse" label-width="80px">
        <!-- 课程名称 -->
        <el-form-item label="课程名称">
          <el-input
            style="width: 20%"
            size="mini"
            v-model="formNewCourse.course_name"
          ></el-input>
        </el-form-item>
        <!-- 课程作者 -->
        <el-form-item label="作者">
          <el-input
            style="width: 20%"
            size="mini"
            v-model="formNewCourse.author"
          ></el-input>
        </el-form-item>
        <!-- 封面 -->
        <el-form-item label="课程封面">
          <up-load
            @getImageURl="getImageURl"
            :default_image="formNewCourse.course_cover"
          ></up-load>
        </el-form-item>
        <!-- 简介 -->
        <el-form-item label="课程简介">
          <el-input
            style="width: 40%"
            type="textarea"
            v-model="formNewCourse.course_info"
          ></el-input>
        </el-form-item>
        <!-- 售价 -->
        <el-form-item label="售价">
          <el-input
            style="width: 20%"
            size="mini"
            v-model="formNewCourse.course_price"
          ></el-input>
        </el-form-item>
        <!-- 划线价 -->
        <el-form-item label="划线价">
          <el-input
            style="width: 20%"
            size="mini"
            v-model="formNewCourse.underlined_price"
          ></el-input>
        </el-form-item>
        <!-- 会员专享 -->
        <el-form-item label="会员专享">
          <el-switch v-model="formNewCourse.member_discount"></el-switch>
        </el-form-item>
        <!-- 课程分组 -->
        <el-form-item label="课程分组">
          <!-- <chapter-manage
            :courseId="formNewCourse.course_id"
            :dynamicTagsProp="chapterList"
          ></chapter-manage> -->
          <drag-list :dynamicTagsProp="chapterList"></drag-list>
        </el-form-item>
        <!-- 提交表单 -->
        <el-form-item>
          <el-button size="mini" type="primary" @click="onSubmitNewCourse"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
import UpLoad from "../../components/common/other/UpLoad";
import { tpx_app } from "../../network/request";
// import ChapterManage from "../certificate/ChapterManage";
import DragList from "../../components/common/other/DragList";
export default {
  name: "creat-new-course",
  components: {
    "up-load": UpLoad,
    // ChapterManage,
    DragList,
  },
  data() {
    return {
      formNewCourse: {},
      chapterList: [],
    };
  },
  mounted() {
    this.formNewCourse = this.$route.query.course_item;
    this.$http
      .get(`/get_course_chapter?course_id=${this.formNewCourse.course_id}`)
      .then((res) => {
        this.chapterList = res.data.data;
      });
  },
  watch: {
    formNewCourse(newValue) {
      this.formNewCourse = newValue;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    // 上传图片后获得链接
    getImageURl(value) {
      this.formNewCourse.course_cover = value;
    },
    // 提交课程
    onSubmitNewCourse() {
      console.log(this.formNewCourse);
      return;
      tpx_app({
        url: "/creat_new_course",
        method: "POST",
        data: this.formNewCourse,
      }).then((res) => {
        // console.log(res);
        const { errno, errmsg } = res.data;
        if (errno == "0") {
          this.$notify({
            title: "成功",
            message: errmsg,
            type: "success",
          });
          this.$router.go(-1);
        } else {
          this.$$notify.error({
            title: "错误",
            message: errmsg,
          });
        }
      });
    },
  },
};
</script>

<style>
</style>